require("./z-shop-js-env");
require("./style.css");

exports.classnames = require("classnames");
exports.react = require("react");
exports["react-dom"] = require("react-dom");
exports["z-shop-event-bus"] = require("./z-shop-event-bus");
exports["zalando-consent-api"] = require("./zalando-consent-api");
exports["safe-fetch"] = require("./fetch-extension");
